import React from 'react';
import { motion } from 'framer-motion';
import { Target, CheckCircle2 } from 'lucide-react';
export function Slide2Strategy() {
  const strategy = ['Act as an aisle breaker', 'Avoid feeling like a survey or lead form', 'Create a premium, fast, rewarding experience', 'Generate leads and booth conversations', 'Capture market intelligence', "Measure Minerva's perceived relevance"];
  const results = ['The aisle-breaker intent did not land — the booth was used only 3 times', 'Engagement came through the QR route, not booth foot traffic', '57% of those who opened the Snak chose to engage', 'Strong completion through the insight questions', '12 qualified leads captured and clear market intelligence gathered', 'Minerva rated strongly against key challenges'];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-579">
      <div className="mb-12" data-id="element-580">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-581">
          The intent vs. what actually happened
        </h2>
        <p className="text-xl text-slate-500" data-id="element-582">
          The aisle-breaker ambition didn’t materialise — but the QR layer
          carried it, behaving like an Industry Pulse rather than a form.
        </p>
      </div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-583">
        {/* Strategy Column */}
        <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200" data-id="element-584">
          <div className="flex items-center gap-3 mb-8" data-id="element-585">
            <div className="p-3 bg-slate-200 rounded-xl" data-id="element-586">
              <Target className="w-6 h-6 text-slate-700" data-id="element-587" />
            </div>
            <h3 className="text-2xl font-bold text-slate-800" data-id="element-588">
              Original Strategic Intent
            </h3>
          </div>

          <div className="space-y-6" data-id="element-589">
            {strategy.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} className="flex items-start gap-4" data-id="element-590">
                <div className="w-2 h-2 rounded-full bg-slate-400 mt-2.5 shrink-0" data-id="element-591" />
                <p className="text-lg text-slate-600" data-id="element-592">{item}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Results Column */}
        <div className="bg-white rounded-3xl p-8 border border-minerva-blue/20 shadow-lg shadow-minerva-blue/5 relative overflow-hidden" data-id="element-593">
          <div className="absolute top-0 right-0 w-64 h-64 bg-minerva-blue/5 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-594" />

          <div className="flex items-center gap-3 mb-8 relative" data-id="element-595">
            <div className="p-3 bg-minerva-blue/10 rounded-xl" data-id="element-596">
              <CheckCircle2 className="w-6 h-6 text-minerva-blue" data-id="element-597" />
            </div>
            <h3 className="text-2xl font-bold text-minerva-dark" data-id="element-598">
              What Happened
            </h3>
          </div>

          <div className="space-y-6 relative" data-id="element-599">
            {results.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4 + i * 0.1
          }} className="flex items-start gap-4" data-id="element-600">
                <div className="w-2 h-2 rounded-full bg-minerva-blue mt-2.5 shrink-0 shadow-[0_0_8px_rgba(0,133,189,0.5)]" data-id="element-601" />
                <p className="text-lg text-slate-800 font-medium" data-id="element-602">{item}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}